import type { EsgDataQueryParams, EsgDataResponse } from './types';

import { ENDPOINT } from '~/constants';

import { type KyRequestOptions } from '@vestigas/data';

import { vestigasApi } from '~/services/kyClient';

import { withoutObjectKeysWhereValueIs } from '@vestigas/utils';

import {
  zodEsgDataQueryParamsSchema,
  zodEsgDataResponseSchema,
} from './validations';

/**
 * Fetches ESG data from the API with the given query parameters.
 *
 * Note: User will override this with mock data in browser dev tools for testing
 * until the actual API endpoint is available.
 *
 * @param queryParams - The query parameters for fetching the ESG data.
 * @param options - Additional options for the request (e.g., abort signal).
 * @returns The ESG data including paginated table items with hierarchy for row grouping.
 * @throws Error if the API request fails.
 * @see https://app.dev.vestigas.com/redoc#tag/Delivery-Note-Items/operation/esg_values_asset_delivery_note_items_esg_values_get
 */
export const fetchEsgData = async (
  queryParams: EsgDataQueryParams,
  options?: KyRequestOptions,
) => {
  return await vestigasApi
    .get(ENDPOINT.DELIVERY_NOTE.GET_ESG_DATA(), {
      ...options,
      searchParams: { ...queryParams },
      validate: {
        ...options?.validate,
        searchParams: zodEsgDataQueryParamsSchema.transform((data) =>
          withoutObjectKeysWhereValueIs(data, [undefined, '']),
        ),
        response: zodEsgDataResponseSchema,
      },
    })
    .json<EsgDataResponse>();
};
